module.exports = __webpack_public_path__ + "static/media/rise.fdd745db.jpg";